module.exports = __webpack_public_path__ + "dashboard/img/de.ced82faf66323ec16ff9939d46e9b0c9.svg";